'use client'

import React from 'react'
import clsx from 'clsx'
import { AnimatePresence, motion } from 'framer-motion'

type Props = {
  className?: string
  title?: string
  optional: boolean
}

export default function OptionalLabel({
  className = '',
  title = 'Optional',
  optional,
}: Props) {
  return (
    <AnimatePresence initial={false}>
      {optional && (
        <motion.span
          initial={{ y: '-100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '-100%', opacity: 0 }}
          className={clsx('text-sm leading-6 text-gray-500', className)}
        >
          {title}
        </motion.span>
      )}
    </AnimatePresence>
  )
}
